// App.js
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useGoogleAnalytics } from './hooks/useGoogleAnalytics';

import About from './pages/About';
import InspGreet from './pages/InspGreet';
import Layout from './components/Layout';
import DisciplineList from './pages/DisciplineList';
import ToshbaClassList from './pages/ToshbaClassList';
import ToshbaDomainDetail from './pages/ToshbaDomainDetail';
import ToshbaSubTopicDetail from './pages/ToshbaSubTopicDetail';
import ToshbaGmaraFoundations from './pages/ToshbaGmaraFoundations';
import ToshbaGmaraStructure from './pages/ToshbaGmaraStructure';
import ToshbaMishnaPlan from './pages/ToshbaMishnaPlan';
import ToshbaMishnaFoundations from './pages/ToshbaMishnaFoundations';
import ToshbaHalachaPlan from './pages/ToshbaHalachaPlan';
import ToshbaHalachaSkills from './pages/ToshbaHalachaSkills';
import ToshbaMishnaChapterDetail from './pages/ToshbaMishnaChapterDetail';
import ToshbaHalachaBookDetail from './pages/ToshbaHalachaBookDetail';
import ToshbaHalachaBookSubtopicDetail from './pages/ToshbaHalachaBookSubtopicDetail';
import HowToTeachList from './pages/HowToTeachList';
import HowToTeachTopicDetail from './pages/HowToTeachTopicDetail';
import JewishThoughtSubTopicList from './pages/JewishThoughtSubTopicList';
import JewishThoughtSubTopicDetail from './pages/JewishThoughtSubTopicDetail';
import JewishThoughtSourceDetail from './pages/JewishThoughtSourceDetail';
import TanachBookList from './pages/TanachBookList';
import TanachBookDetail from './pages/TanachBookDetail';
import TanachBookChaptersList from './pages/TanachBookChaptersList';
import TanachChapterDetail from './pages/TanachChapterDetail';
import TanachTopicDetail from './pages/TanachTopicDetail';
import SchoolRabbisMainTopicList from './pages/SchoolRabbisMainTopicList';
import SchoolRabbisMainTopicDetail from './pages/SchoolRabbisMainTopicDetail';
import SchoolRabbisSecondaryTopicDetail from './pages/SchoolRabbisSecondaryTopicDetail';
import SchoolRabbisProjectDetail from './pages/SchoolRabbisProjectDetail';

function AppRoutes() {

  // Track page views on route changes
  useGoogleAnalytics();

  return (
    <Routes>
      {/* Root → disciplines */}
      <Route path="/" element={<Navigate to="/disciplines" />} />

      {/* Public app (no auth) */}
      <Route element={<Layout />}>
        {/* Disciplines */}
        <Route path="/disciplines" element={<DisciplineList />} />

        {/* תושב"ע discipline */}
        <Route path="/toshba/classes" element={<ToshbaClassList />} />
        <Route path="/toshba/classes/:domain" element={<ToshbaDomainDetail />} />
        <Route path="/toshba/classes/gmara/foundations" element={<ToshbaGmaraFoundations />} />
        <Route path="/toshba/classes/gmara/structure" element={<ToshbaGmaraStructure />} />
        <Route path="/toshba/classes/mishna/plan" element={<ToshbaMishnaPlan />} />
        <Route path="/toshba/classes/mishna/foundations" element={<ToshbaMishnaFoundations />} />
        <Route path="/toshba/classes/halacha/plan" element={<ToshbaHalachaPlan />} />
        <Route path="/toshba/classes/halacha/skills" element={<ToshbaHalachaSkills />} />
        <Route path="/toshba/classes/:domain/:id" element={<ToshbaSubTopicDetail />} />
        <Route path="/toshba/classes/:domain/:subtopicId/chapters/:id" element={<ToshbaMishnaChapterDetail />} />
        <Route path="/toshba/classes/:domain/:subtopicId/books/:id" element={<ToshbaHalachaBookDetail />} />
        <Route path="/toshba/classes/:domain/:subtopicId/books/:bookId/subtopics/:id" element={<ToshbaHalachaBookSubtopicDetail />} />

        {/* How to Teach Toshba */}
        <Route path="/toshba/how-to-teach" element={<HowToTeachList />} />
        <Route path="/toshba/how-to-teach/:topicType" element={<HowToTeachTopicDetail />} />

        {/* מחשבת ישראל discipline */}
        <Route path="/jewish-thought/subtopics" element={<JewishThoughtSubTopicList />} />
        <Route path="/jewish-thought/subtopics/:id" element={<JewishThoughtSubTopicDetail />} />
        <Route path="/jewish-thought/subtopics/:subtopicId/sources/:id" element={<JewishThoughtSourceDetail />} />

        {/* תנ"ך discipline */}
        <Route path="/tanach/books" element={<TanachBookList />} />
        <Route path="/tanach/books/:id/general-topics" element={<TanachBookDetail />} />
        <Route path="/tanach/books/:id/chapters" element={<TanachBookChaptersList />} />
        <Route path="/tanach/books/:id/chapters/:chapterId" element={<TanachChapterDetail />} />
        <Route path="/tanach/books/:id/chapters/:chapterId/topics/:topicId" element={<TanachTopicDetail />} />

        {/* רבני בתי ספר discipline */}
        <Route path="/school-rabbis/main-topics" element={<SchoolRabbisMainTopicList />} />
        <Route path="/school-rabbis/main-topics/:id" element={<SchoolRabbisMainTopicDetail />} />
        <Route path="/school-rabbis/main-topics/:mainTopicId/secondary-topics/:id" element={<SchoolRabbisSecondaryTopicDetail />} />
        <Route path="/school-rabbis/main-topics/:mainTopicId/secondary-topics/:secondaryTopicId/projects/:id" element={<SchoolRabbisProjectDetail />} />

        <Route path="/about" element={<About />} />
        <Route path="/inspGreet" element={<InspGreet />} />
      </Route>
    </Routes>
  );
}

export default function WrappedApp() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}